var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiagnostics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st0{fill:#de7c73}.st1{fill:#48b2d2}.st3{fill:gray}")), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 149.528,
    cy: 222.63,
    r: 28.108,
    id: "circle4",
    style: {
      strokeWidth: 1.72128
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "translate(-216.83 -215.676) scale(1.72128)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.29 255.16c.28 17.61 14.4 31.75 31.84 32.24v-65.52c-17.9.51-32.12 15.32-31.84 33.28z",
    id: "path6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g14",
    transform: "translate(-216.83 -215.676) scale(1.72128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.56 255.16c-.28 17.61-14.4 31.75-31.84 32.24v-65.52c17.91.51 32.13 15.32 31.84 33.28z",
    id: "path10"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 475.555,
    cy: 222.63,
    r: 28.108,
    id: "circle16",
    style: {
      strokeWidth: 1.72128
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.881,
    cy: 222.63,
    r: 28.108,
    id: "circle18",
    style: {
      strokeWidth: 1.72128,
      fill: "#e79933"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M315.476 71.278c-85.84 0-155.672 66.528-155.672 148.306 0 30.793 9.914 59.435 26.852 83.172L21.465 476.175c-11.378 11.945-10.879 30.88 1.101 42.292 11.98 11.412 30.915 10.998 42.292-.947l165.553-173.798c24.46 15.268 53.686 24.167 85.065 24.167 85.84 0 155.673-66.527 155.673-148.305S401.317 71.278 315.476 71.278zm0 244.267c-55.528 0-100.712-43.05-100.712-95.944 0-52.895 45.184-95.944 100.712-95.944 55.546 0 100.73 43.049 100.73 95.944s-45.184 95.944-100.73 95.944z",
    id: "path20",
    style: {
      strokeWidth: 1.72128
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.104,
    cy: 222.63,
    r: 56.424,
    id: "circle22",
    style: {
      strokeWidth: 1.72128,
      fill: "#65ab65"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M249.242 164.193c4.63-6.661 22.393-27.885 60.76-28.711 1.911-.034 3.822.62 5.216 1.928 1.928 1.824 2.41 4.424-8.469 5.387-.395.035-.774.052-1.17.07-3.58.05-27.54 1.239-48.867 22.806 0 0-7.212 9.209-8.555 3.426-.379-1.705.086-3.477 1.085-4.906z",
    id: "path24",
    style: {
      strokeWidth: 1.72128
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnostics);
export default __webpack_public_path__ + "static/media/diagnostics.968a9301eb98cb3f8ffe8f314ad5deec.svg";
export { ForwardRef as ReactComponent };